var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutubeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1301_607)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3406 4.8002C16.3406 4.8002 16.1844 3.69707 15.7031 3.2127C15.0938 2.5752 14.4125 2.57207 14.1 2.53457C11.8625 2.37207 8.50313 2.37207 8.50313 2.37207H8.49687C8.49687 2.37207 5.1375 2.37207 2.9 2.53457C2.5875 2.57207 1.90625 2.5752 1.29688 3.2127C0.815625 3.69707 0.6625 4.8002 0.6625 4.8002C0.6625 4.8002 0.5 6.09707 0.5 7.39082V8.60332C0.5 9.89707 0.659375 11.1939 0.659375 11.1939C0.659375 11.1939 0.815625 12.2971 1.29375 12.7814C1.90313 13.4189 2.70313 13.3971 3.05938 13.4658C4.34063 13.5877 8.5 13.6252 8.5 13.6252C8.5 13.6252 11.8625 13.6189 14.1 13.4596C14.4125 13.4221 15.0938 13.4189 15.7031 12.7814C16.1844 12.2971 16.3406 11.1939 16.3406 11.1939C16.3406 11.1939 16.5 9.90019 16.5 8.60332V7.39082C16.5 6.09707 16.3406 4.8002 16.3406 4.8002ZM6.84688 10.0752V5.57832L11.1687 7.83457L6.84688 10.0752Z",
    fill: "#686E84"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1301_607"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIcon);
export default __webpack_public_path__ + "static/media/youtubeIcon.c001c69281ff91d8e6dff75798e747de.svg";
export { ForwardRef as ReactComponent };